module.exports = __webpack_public_path__ + "static/media/dark_planing_no_data.2361ec64.png";